import React, { useEffect, useState } from 'react';
import { api, auth, PROBLEM_AREAS, STATUSES } from '../api/client';
import { StatusBadge, PriorityBadge, Spinner } from './Shared';

export default function TicketList({ onOpen }) {
  const isAdmin = auth.isAdmin;
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [statusFilter, setStatusFilter] = useState(isAdmin ? 'Open' : '');
  const [areaFilter, setAreaFilter] = useState('');
  const effectiveStatusFilter = isAdmin ? 'Open' : statusFilter;

  async function load() {
    setLoading(true); setError('');
    try {
      const data = await api.listTickets({ status: effectiveStatusFilter, area: areaFilter });
      setTickets(data || []);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [effectiveStatusFilter, areaFilter]);

  return (
    <div className="screen">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
        <div>
          <h1>{isAdmin ? 'Open tickets' : 'My tickets'}</h1>
          <p className="faint">{isAdmin ? 'Admin view' : auth.user?.companyName}</p>
        </div>
        <button className="btn btn-ghost btn-sm" onClick={load}>↻ Refresh</button>
      </div>

      <div className="row" style={{ marginBottom: 14 }}>
        {!isAdmin && (
          <select className="select" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="">All status</option>
            {STATUSES.map((s) => <option key={s.key} value={s.key}>{s.label}</option>)}
          </select>
        )}
        <select className="select" value={areaFilter} onChange={(e) => setAreaFilter(e.target.value)}>
          <option value="">All areas</option>
          {PROBLEM_AREAS.map((a) => <option key={a.key} value={a.key}>{a.label}</option>)}
        </select>
      </div>

      {loading && <Spinner big />}
      {error && <p className="error-text">{error}</p>}

      {!loading && tickets.length === 0 && (
        <div className="empty">
          <span className="ic">🎫</span>
          No tickets yet.
          {!isAdmin && <div className="faint" style={{ marginTop: 6 }}>Tap + to raise one.</div>}
        </div>
      )}

      {tickets.map((t) => (
        <div className="ticket" key={t.id} onClick={() => onOpen(t.id)}>
          <div className="ticket-head">
            <div className="ticket-title">#{t.id} · {t.title}</div>
            <StatusBadge status={t.status} />
          </div>
          {t.description && (
            <p className="faint" style={{ marginTop: 6, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {t.description}
            </p>
          )}
          <div className="ticket-meta">
            <span className="ticket-area">{areaLabel(t.problemArea)}</span>
            <PriorityBadge priority={t.priority} />
            {t.images?.length > 0 && <span className="faint">📎 {t.images.length}</span>}
            <span className="faint" style={{ marginLeft: 'auto' }}>{fmtDate(t.createdAt)}</span>
          </div>
          {isAdmin && (
            <p className="faint" style={{ marginTop: 8 }}>
              {t.userName} · {t.companyName} · {t.clientLocation}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}

function areaLabel(key) {
  const found = PROBLEM_AREAS.find((a) => a.key === key);
  return found ? found.label : key;
}
function fmtDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
  } catch { return ''; }
}
